import { combineReducers } from 'redux';
import authReducer from './auth-reducer';

const rootReducer = combineReducers({
  auth: authReducer,
  // ajout d'autres réducteurs si nécessaire
});

export default rootReducer;
